import './index.css';

(function () {
    const accordions = document.querySelectorAll('[data-accordion]');
    if (!accordions.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideDown(el) {
        if (!el) return;
        el.hidden = false;
        if (reduceMotion) return;

        el.style.overflow = 'hidden';
        el.style.height = '0px';
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        el.offsetHeight;

        const target = el.scrollHeight;
        el.style.transition = 'height 300ms ease';
        el.style.height = target + 'px';

        el.addEventListener('transitionend', function onEnd(e) {
            if (e.propertyName !== 'height') return;
            el.removeEventListener('transitionend', onEnd);
            el.style.height = '';
            el.style.overflow = '';
            el.style.transition = '';
        }, { once: true });
    }

    function slideUp(el) {
        if (!el || el.hidden) return;
        if (reduceMotion) { el.hidden = true; return; }

        el.style.overflow = 'hidden';
        el.style.height = el.offsetHeight + 'px';
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        el.offsetHeight;

        el.style.transition = 'height 300ms ease';
        el.style.height = '0px';

        el.addEventListener('transitionend', function onEnd(e) {
            if (e.propertyName !== 'height') return;
            el.removeEventListener('transitionend', onEnd);
            el.hidden = true;
            el.style.height = '';
            el.style.overflow = '';
            el.style.transition = '';
        }, { once: true });
    }

    accordions.forEach(acc => {
        acc.addEventListener('click', function (e) {
            let btn = e.target.closest('[data-acc-button]');
            if (!btn && e.target.closest('.plus-minus-icon')) {
                // If clicking icon, find its sibling button
                btn = e.target.closest('.c-accordion__title')?.querySelector('[data-acc-button]');
            }
            if (!btn || !acc.contains(btn)) return;

            const panelId = btn.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
            if (!panel) return;

            const isOpen = btn.getAttribute('aria-expanded') === 'true';

            // Close all
            const allButtons = acc.querySelectorAll('[data-acc-button]');
            const allPanels = acc.querySelectorAll('[data-acc-panel]');
            allButtons.forEach(b => b.setAttribute('aria-expanded', 'false'));
            allPanels.forEach(p => slideUp(p));
            acc.querySelectorAll('.plus-minus-icon.minus').forEach(ic => ic.classList.remove('minus'));

            // Open clicked (and flip icon) if it wasn't open
            if (!isOpen) {
                btn.setAttribute('aria-expanded', 'true');
                slideDown(panel);

                const title = btn.closest('.c-accordion__title');
                const icon = title ? title.querySelector('.plus-minus-icon') : null;
                if (icon) icon.classList.add('minus');
            }
        });

        // Keyboard nav (optional)
        acc.addEventListener('keydown', function (e) {
            const keys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
            if (!keys.includes(e.key)) return;

            const buttons = Array.from(acc.querySelectorAll('[data-acc-button]'));
            const current = document.activeElement;
            const idx = buttons.indexOf(current);
            if (idx === -1) return;

            let nextIdx = idx;
            if (e.key === 'ArrowUp') nextIdx = (idx - 1 + buttons.length) % buttons.length;
            if (e.key === 'ArrowDown') nextIdx = (idx + 1) % buttons.length;
            if (e.key === 'Home') nextIdx = 0;
            if (e.key === 'End') nextIdx = buttons.length - 1;

            buttons[nextIdx].focus();
            e.preventDefault();
        });
    });
})();
